import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import CyberInsuranceHero from './components/CyberInsuranceHero';
import UnderstandingQuestionnaires from './components/UnderstandingQuestionnaires';
import KeyAreasEvaluated from './components/KeyAreasEvaluated';
import CommonQuestions from './components/CommonQuestions';
import BestPractices from './components/BestPractices';
import QuestionsToAsk from './components/QuestionsToAsk';
import WhyItMatters from './components/WhyItMatters';

export default function CyberInsuranceChecklistPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CyberInsuranceHero />
      <UnderstandingQuestionnaires />
      <KeyAreasEvaluated />
      <CommonQuestions />
      <BestPractices />
      <QuestionsToAsk />
      <WhyItMatters />
      <Footer />
    </div>
  );
}